import { NgModule } from '@angular/core';
import { CodeConfirmComponent } from './code-confirm.component';
import { UIModule } from '../../ui/ui.module';
import { SharedModule } from "../../modules/shared/shared.module";
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    CodeConfirmComponent,
  ],
  exports: [
    CodeConfirmComponent
  ],
  imports: [
    UIModule,
    SharedModule,
    ReactiveFormsModule
  ],
})
export class CodeConfirmModule { }
